import React from 'react';
import { IEquityHistoryTable } from './IEquityHistoryTable';
import EquityHistoryNav from '../EquityHistoryNav/EquityHistoryNav';

export const EquityHistoryTable = (props: IEquityHistoryTable) => {

  return (
    <div>
      <EquityHistoryNav />
      <p>Hello EquityHistoryTable</p>
    </div>
  );
};

export default EquityHistoryTable;
